<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
    [nzVisible]="isVisiblePreferredVendorsDrawer" [nzTitle]="preferredVendorsDrawerTitle" [nzFooter]="footerTpl"
    (nzOnClose)="handleCancel()">
    <ng-container *nzDrawerContent>
        <form nz-form [formGroup]="_fS.preferredVendorForm">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="companyNameError">
                            <label class="label-text required">Company name</label>
                            <!-- (keypress)="_cs.checkAlphabetsWithSpace($event)"-->
                            <input class="input-group" nz-input formControlName="companyName" minlength="2"
                                maxlength="100" />
                            <ng-template #companyNameError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter Company
                                    name</ng-container>
                                <ng-container *ngIf="control.hasError('minlength')">Company name Must Contain At Least 2
                                    Characters
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="vendorDisplayNameError">
                            <label class="label-text required">Vendor display name</label>
                            <input class="input-group" nz-input formControlName="vendorDisplayName" minlength="2"
                                maxlength="100" />
                            <ng-template #vendorDisplayNameError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter vendor display
                                    name</ng-container>
                                <ng-container *ngIf="control.hasError('minlength')">Vendor display name Must Contain At
                                    Least 2 Characters
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzSpan="12">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="phoneError" class="phone-input-box">
                            <label class="label-text required">Mobile number</label>
                            <nz-input-group>
                                <input class="input-group" nz-input formControlName="phoneNumber"
                                    (paste)="_cs.checkNumbers($event)" (keypress)="_cs.checkNumbers($event)"
                                    mask="(000) 000-0000"
                                    pattern="^(?\d{3}\)?[\s.\s]\d{3}[\s.-]\d{4}$"></nz-input-group>
                            <ng-template #phoneError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter Mobile number
                                </ng-container>
                                <ng-container *ngIf="control.hasError('pattern')">
                                    Mobile number must contain at least 10 digits
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzSpan="12">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="emailAddressError">
                            <label class="label-text required">Email address</label>
                            <input class="input-group" nz-input formControlName="emailAddress" name="fname"
                                pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}" />
                            <ng-template #emailAddressError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter Email address
                                </ng-container>
                                <ng-container *ngIf="control.hasError('pattern')">Enter valid Email address
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>


            <nz-collapse nzGhost class="form-collapse-custom-panel p-0 mb-1">
                <nz-collapse-panel [nzHeader]="'Add Address'" [nzActive]="isAddAddressClicked"
                    (nzActiveChange)="addAddressClicked($event)" class="p-0">
                    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0">
                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" *ngIf="!LineStreetAddress">
                            <nz-form-item>
                                <nz-form-control [nzErrorTip]="address1Error">
                                    <label class="label-text">Address 1</label>
                                    <input class="input-group" nz-input formControlName="address1" minlength="2"
                                        maxlength="100" />
                                    <ng-template #address1Error let-control>
                                        <ng-container *ngIf="control.hasError('required')">Please enter address
                                            1</ng-container>
                                        <ng-container *ngIf="control.hasError('minlength')">Address
                                            {{validationMessage.minlength}}
                                        </ng-container>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                            <!-- <div (click)="addInternationalAddress(!LineStreetAddress)">
                                <span nz-icon nzType="down" nzTheme="outline"></span><label>International</label>
                            </div> -->
                            <span *ngIf="!LineStreetAddress" (click)="addInternationalAddress(!LineStreetAddress)" class="cursor fs-14 international-btn"><span nz-icon nzType="down" class="pr-12 fs-12" nzTheme="outline"></span>International</span>
                        </div>
                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" *ngIf="!LineStreetAddress">
                            <nz-form-item>
                                <nz-form-control>
                                    <!-- <label class="label-text required">Address 2</label> -->
                                    <label class="label-text">Address 2</label>
                                    <input class="input-group" nz-input formControlName="address2" minlength="2"
                                        maxlength="100" />
                                    <!-- <ng-template #address2Error let-control>
                                            <ng-container *ngIf="control.hasError('required')">Please enter Address 2</ng-container>
                                            <ng-container *ngIf="control.hasError('minlength')">Address {{validationMessage.minlength}}
                                            </ng-container>
                                        </ng-template> -->
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                    </div>
                    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0">
                        <div *ngIf="LineStreetAddress" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24"
                            class="pl-0">
                            <nz-form-item class="mb-0">
                                <nz-form-control [nzErrorTip]="address1Error">
                                    <!-- <label class="label-text">street address</label> -->
                                    <label class="label-text">International address</label>
                                    <textarea type="text"
                                        pattern="^[A-Z-a-z0-9,./#@'?^*%$&!;:-_()+=&quot;{}|\n\s][A-Z-a-z0-9 ,./#@'?^*%$&!;:-_()+=&quot;{}|\s\r\n]{1,150}$"
                                        class="input-group" rows="4" nz-input formControlName="address1" maxlength="1000"
                                        minlength="2"></textarea>
                                    <!-- <div (click)="addInternationalAddress(!LineStreetAddress)" class="cursor fs-14"><span
                                            nz-icon [nzType]="'down'" nzTheme="outline" class="pr-12 fs-12"></span>US
                                        Address
                                    </div> -->

                                    <span (click)="addInternationalAddress(!LineStreetAddress)" class="cursor fs-14"><span nz-icon nzType="down" class="pr-12 fs-12" nzTheme="outline"></span>US Address</span>
                                    <ng-template #address1Error let-control>
                                        <ng-container *ngIf="control.hasError('required')">Please enter International
                                            address
                                        </ng-container>
                                        <ng-container *ngIf="control.hasError('minlength')">International address must
                                            contain at
                                            least 2
                                            characters
                                        </ng-container>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                    </div>
                    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0">

                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" *ngIf="!LineStreetAddress">
                            <nz-form-item>
                                <nz-form-control [nzErrorTip]="citytownError">
                                    <label class="label-text">City/Town</label>
                                    <input class="input-group" nz-input formControlName="city" />
                                    <ng-template #citytownError let-control>
                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                            city/town
                                        </ng-container>
                                        <ng-container *ngIf="control.hasError('pattern')">Enter valid
                                            city/town
                                        </ng-container>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                        </div>

                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" *ngIf="!LineStreetAddress">
                            <nz-form-item>
                                <nz-form-control [nzErrorTip]="stateError">
                                    <label class="label-text">State</label>
                                    <nz-select nzShowSearch nzPlaceHolder="Select State" [nzSize]="'default'"
                                        formControlName="state" [nzSelectOnTab]="true"
                                        (ngModelChange)="focusZipCode($event)">
                                        <nz-option *ngFor="let option of listOfStates" [nzLabel]="option"
                                            [nzValue]="option"></nz-option>
                                    </nz-select>
                                    <ng-template #stateError let-control>
                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                            state
                                        </ng-container>
                                        <ng-container *ngIf="control.hasError('pattern')">Enter valid state
                                        </ng-container>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                        </div>

                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" *ngIf="!LineStreetAddress">
                            <nz-form-item>
                                <nz-form-control [nzErrorTip]="zipcodeError">
                                    <label class="label-text">Zip code</label>
                                    <input #zipcode class="input-group" nz-input formControlName="zipcode"
                                        (keypress)="_cs.checkNumbers($event)" mask="00000||00000-0000" minlength="5" />
                                    <ng-template #zipcodeError let-control>
                                        <ng-container *ngIf="control.hasError('required')">Please enter zip
                                            code
                                        </ng-container>
                                        <ng-container *ngIf="control.hasError('pattern')">Enter valid zip
                                            code
                                        </ng-container>
                                        <ng-container *ngIf="control.hasError('minlength')">Zip code must contain at
                                            least 5
                                            digits
                                        </ng-container>
                                        <ng-container
                                            *ngIf="_fS.preferredVendorForm.get('zipcode').value.length > 5 && _fS.preferredVendorForm.get('zipcode').value.length < 9">Please
                                            enter valid zipcode (XXXXX-XXXX or XXXXX)
                                        </ng-container>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                        </div>


                        <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" *ngIf="!LineStreetAddress">
                            <nz-form-item>
                                <nz-form-control [nzErrorTip]="countryError">
                                    <label class="label-text">Country</label>
                                    <!-- [readonly]="'true'"-->
                                    <input class="input-group" nz-input formControlName="country" />
                                    <ng-template #countryError let-control>
                                        <ng-container *ngIf="control.hasError('required')">Please enter
                                            country
                                        </ng-container>
                                        <ng-container *ngIf="control.hasError('pattern')">Enter valid
                                            country
                                        </ng-container>
                                    </ng-template>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                    </div>
                </nz-collapse-panel>
            </nz-collapse>

            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0">
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <nz-form-item class="margin-none">
                        <nz-form-control class="switch-box">
                            <nz-switch formControlName="ispreferredVendorActive"></nz-switch>
                            <label class="switch-label black mr-1">Visible</label>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
        </form>
    </ng-container>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end">
            <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingOne"
                class="medium-btn small-btn width-100 mr-1">{{selectedPreferredVendorsData != null ? 'Update' :
                'Add'}}</button>
            <button nz-button nzType="default" (click)="handleCancel()" class="default-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>